(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner-3d"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pb3d-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-pb3d-copy');
    if (navigator.clipboard && code) {
      navigator.clipboard.writeText(code).catch(function () {});
    }
    btn.classList.add('is-copied');
    setTimeout(function () {
      btn.classList.remove('is-copied');
    }, 1600);
  });

  } catch(e) { console.error(e); }
})();
})();
